import { FC } from "react";
import "@rmwc/ripple/styles";
import { Ripple as MDRipple } from "@rmwc/ripple";

export type RippleTypes = {
  accent?: boolean;
  disabled?: boolean;
  primary?: boolean;
  className?: string;
  surface?: boolean;
  unbounded?: boolean;
  width?: number | string;
  height?: number | string;
};

const Ripple: FC<RippleTypes> = (props) => {
  const {
    accent = false,
    children,
    className,
    disabled,
    primary = false,
    surface,
    unbounded = false,
    height,
    width,
  } = props;

  return (
    <MDRipple
      accent={accent}
      disabled={disabled}
      className={className}
      primary={primary}
      surface={surface}
      unbounded={unbounded}
      width={width}
      height={height}
    >
      {children}
    </MDRipple>
  );
};

export default Ripple;
